
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const rook: Operator = {
	id: 'rook',
	name: 'Rook',
	role: 'Defender',
	org: 'GIGN',
	squad: 'VIPERSTRIKE',
	ratings: {
		health: 3,
		speed: 1,
		difficulty: 1
	},
	meta: {
		gender: 'm',
		country: 'fr',
		season: 'Release',
		height: 175,
		weight: 72,
		price: {
			renown: 1000,
			r6credits: 0
		}
	},
	bio: {
		real_name: 'Julien Nizan',
		birthplace: 'Tours, France'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M238.5 73.479v25.303h-12V77.081c0-6.046-4.901-10.947-10.947-10.947h-81.606c-6.046 0-10.947 4.901-10.947 10.947v21.701h-11.5V73.479H73V277h204V73.479zm-107.375 3.938a3 3 0 0 1 3-3h81.25a3 3 0 0 1 3 3v21.365h-87.25z" style="fill:#3b6183"></path><path d="M252.528 204.405v-18.35h-15.89v-9.013l-12.918-4.505 4.966-56.771-28.145-7.83c.216 1.546 1.483 11.849-5.947 20.265-7.028 7.96-16.592 8.291-18.922 8.372-2.101.073-13.485.467-21.195-8.678-7.028-8.336-5.743-18.361-5.505-20.008l-28.159 7.878 4.966 56.771-12.918 4.505v9.013H96.972v18.35l15.889 4.722v8.63H96.972v18.652l15.889 4.416v9.666l25.601 19.141h72.576l25.601-19.141v-9.666l15.889-4.416v-18.652h-15.889v-8.63z" style="fill:#fff"></path><path d="M247.778 200.861v-10.056h-11.167v-2.389h-4.722v-8l-13.222-4.611 4.944-56.528-18.278-5.125c-.238 2.841-1.259 10.439-7.167 17.181-8.163 9.313-19.43 9.887-22.33 9.988-3.099.107-16.23.113-25.003-10.377-5.477-6.549-6.441-13.822-6.667-16.792l-18.278 5.125 4.944 56.528-13.222 4.611v8h-4.722v2.389h-11.167v10.056l15.889 4.722v13.556h-4.722v3.368h-11.167v10.292l15.889 4.417v10.896l22.431 16.771h69.417l22.431-16.771v-10.896l15.889-4.417v-10.292h-11.167v-3.368h-4.722v-13.556z"></path><path d="m212.604 178.958 5.146-56.25-8.861-2.375c-.822 3.325-3.119 10.632-9.722 16.833-9.859 9.258-22.007 9.188-25.556 9.111-2.85-.062-18.282-.719-28.028-13.153-3.737-4.767-5.362-9.638-6.125-12.792l-8.625 2.375 5.181 56.264-13.583 4.819v61.319l18.944 14.25h65.986l18.889-14.208v-61.375zM135.5 193.753a2.5 2.5 0 0 1 2.5-2.5h72.5a2.5 2.5 0 0 1 2.5 2.5v.011a2.5 2.5 0 0 1-2.5 2.5H138a2.5 2.5 0 0 1-2.5-2.5zm0 16.304a2.5 2.5 0 0 1 2.5-2.5h72.5a2.5 2.5 0 0 1 2.5 2.5v.011a2.5 2.5 0 0 1-2.5 2.5H138a2.5 2.5 0 0 1-2.5-2.5zm77.59 32.619a2.5 2.5 0 0 1-2.5 2.5h-72.5a2.5 2.5 0 0 1-2.5-2.5v-.011a2.5 2.5 0 0 1 2.5-2.5h72.5a2.5 2.5 0 0 1 2.5 2.5zm0-16.304a2.5 2.5 0 0 1-2.5 2.5h-72.5a2.5 2.5 0 0 1-2.5-2.5v-.011a2.5 2.5 0 0 1 2.5-2.5h72.5a2.5 2.5 0 0 1 2.5 2.5z" style="fill:#fff"></path></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-rook'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
